export enum SocialIconSize {
  '2XS' = '1rem',
  XS = '1.25',
  SM = '1.5rem',
  MD = '2rem',
  LG = '2.5rem',
}
